import outputSubmissionModel from "./outputSubmissionModel";
const {
  formField: {
    // info
    statementReportGuideline,
    //info
    howManyPublicationSubmitC2FReport,
    yourResearchField,
    publicationEvidence
  }
} = outputSubmissionModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // info
  [statementReportGuideline.name]: "",
  //info

  [howManyPublicationSubmitC2FReport.name]: "",
  [yourResearchField.name]: "",
  [publicationEvidence.name]: [
    {
      [publicationEvidence.subMenu[0].journalRanking.name]: "",
      [publicationEvidence.subMenu[0].publicationStatus.name]: "",
      [publicationEvidence.subMenu[0].typeResearchPublication.name]: "",
      [publicationEvidence.subMenu[0].acceptedDate.name]: "",
      [publicationEvidence.subMenu[0].publishedDate.name]: "",
      [publicationEvidence.subMenu[0].doi.name]: "",
      [publicationEvidence.subMenu[0].uploadResearchPublication.name]: null,
      [publicationEvidence.subMenu[0].articleTitle.name]: "",
      [publicationEvidence.subMenu[0].journalName.name]: "",
      [publicationEvidence.subMenu[0].subjectAreaCategory.name]: "",
      [publicationEvidence.subMenu[0].journalRankingPercentagePercentile.name]:
        "",
      [publicationEvidence.subMenu[0].screenshotJournalRankingEvidence.name]:
        null,
      [publicationEvidence.subMenu[0].firstAuthor.name]: "",
      [publicationEvidence.subMenu[0].correspondingAuthor.name]: "",
      [publicationEvidence.subMenu[0].collaboratorFromTop100.name]: "",
      [publicationEvidence.subMenu[0].collaboratorName.name]: "",
      [publicationEvidence.subMenu[0].universityInstituteCollaborator.name]: "",
      [publicationEvidence.subMenu[0].referenceWorldRankingStatus.name]: "",
      [publicationEvidence.subMenu[0].worldRankingYear.name]: "",
      [publicationEvidence.subMenu[0].noWorldRanking.name]: "",
      [publicationEvidence.subMenu[0].evidenceTopInternationalInstitute.name]:
        null,
      [publicationEvidence.subMenu[0].evidenceHighPerformanceProfessor.name]:
        null
    }
  ]
};
